/**
 * Regra da senha do MOF — a mesma que o backend novo aplica (RegraSenha.cs): a do legado
 * (^(?=.*\d)[0-9a-zA-Z$*&@#]{6,}$) mais "pelo menos uma letra". Mostrada na tela item a item.
 */
export const ITENS_REGRA_SENHA: { texto: string; atende: (senha: string) => boolean }[] = [
  { texto: "No mínimo 6 caracteres", atende: (s) => s.length >= 6 },
  { texto: "Pelo menos uma letra", atende: (s) => /[a-zA-Z]/.test(s) },
  { texto: "Pelo menos um número", atende: (s) => /\d/.test(s) },
  {
    texto: "Somente letras sem acento, números e $ * & @ #",
    atende: (s) => s.length > 0 && /^[0-9a-zA-Z$*&@#]+$/.test(s),
  },
];

export function senhaAtendeRegra(senha: string): boolean {
  return ITENS_REGRA_SENHA.every((item) => item.atende(senha));
}
